// extracted by mini-css-extract-plugin
export default {"uploadDropzone":"FileUpload_uploadDropzone__ro448","customUploadHint":"FileUpload_customUploadHint__v4SbI","customUploadNote":"FileUpload_customUploadNote__2onlB"};